import gql from 'graphql-tag';

const GET_SEARCH_DATA = gql`
  query($term: String!, $modules: [String], $filters: JSON, $pageInfo: JSON) {
    search(
      term: $term
      modules: $modules
      filters: $filters
      pageInfo: $pageInfo
    )
  }
`;

const GET_RECENT_SEARCH_DATA = gql`
  query {
    getRecentSearchInfo {
      recentTerms
      recentHits
    }
  }
`;

const UPDATE_RECENT_SEARCH_DATA = gql`
  mutation($term: String, $hit: JSON) {
    updateRecentSearchInfo(term: $term, hit: $hit)
  }
`;

export { GET_SEARCH_DATA, GET_RECENT_SEARCH_DATA, UPDATE_RECENT_SEARCH_DATA };
